import { render } from "./CloseAccount.vue?vue&type=template&id=ef5d910e"
import script from "./CloseAccount.vue?vue&type=script&lang=js"
export * from "./CloseAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__